import React, { useState } from 'react';
import logo from '../img/logo.png';
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import LanguageSelector from './LanguageSelector';

function NavBar() {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className='fixed w-full z-50'>
      <header className="bg-neutral-50 shadow-md py-4">
        <div className="flex items-center px-6">
          <button
            onClick={() => navigate(-1)}
            className="mr-4 text-gray-600 hover:text-gray-800"
          >
            <FaArrowLeft className="text-xl" />
          </button>
          <div className='flex-grow flex justify-center'><a href="/"><img src={logo} alt="Logo" className='h-10' /></a></div>
          <LanguageSelector />
        </div>
      </header>
    </div>

  );
}

export default NavBar;
